export default __webpack_public_path__ + "static/media/13ee7sssasset_4.494e1ab6.png";